// Supervisão de campo: agenda de visitas, vistoria com checklist e fotos, tempos, apontamentos (correção e validação
// por outra pessoa) e relatório emitido com versão. Permissões supervisao.* (servidor confere cada ação).
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Checkbox, Chip, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid,
  List, ListItem, ListItemText, Menu, MenuItem, Paper, Radio, RadioGroup, Tab, Table, TableBody, TableCell, TableHead,
  TableRow, Tabs, TextField, Typography,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import suporteApi, { mensagemErro } from "../api";
import { dataBR } from "../comum";
import { usePermissao } from "../permissoes";
import { EditorPergunta, PreviaPergunta, TIPOS_CHECKLIST, novaPergunta } from "../Formularios";
import QuadroAssinatura from "../QuadroAssinatura";
import { LaudoDaVisita, TextosLaudo } from "../LaudoVistoria";
import { SeletorCliente, SeletorSupervisor, SeletorTecnico } from "../SeletoresCadastro";

const SIT = { AGENDADA: "Agendada", CONFIRMADA: "Confirmada", EM_DESLOCAMENTO: "Em deslocamento", NO_LOCAL: "No local",
  EM_VISTORIA: "Em vistoria", PAUSADA: "Pausada", FINALIZADA: "Finalizada (revisar)", CONCLUIDA: "Concluída",
  IMPEDIDA: "Impedida", CANCELADA: "Cancelada" };
const COR = { CONCLUIDA: "#2e7d32", FINALIZADA: "#6a1b9a", EM_VISTORIA: "#ef6c00", PAUSADA: "#ef6c00", IMPEDIDA: "#c62828", CANCELADA: "#757575" };
const GRAV = { BAIXA: "#607d8b", MEDIA: "#f9a825", ALTA: "#ef6c00", CRITICA: "#c62828" };
// eventos permitidos em cada situação (o servidor também confere)
const EVENTOS = {
  AGENDADA: ["confirmada", "deslocamento", "chegada", "inicio", "impedimento", "reagendada", "cancelada"],
  CONFIRMADA: ["deslocamento", "chegada", "inicio", "impedimento", "reagendada", "cancelada"],
  EM_DESLOCAMENTO: ["chegada", "inicio", "impedimento", "cancelada"],
  NO_LOCAL: ["inicio", "impedimento"], EM_VISTORIA: ["pausa"], PAUSADA: ["retomada"],
  IMPEDIDA: ["reagendada", "cancelada"],
};
const NOME_EV = { confirmada: "Confirmar", deslocamento: "Saiu para o local", chegada: "Chegou", inicio: "Iniciar vistoria",
  pausa: "Pausar", retomada: "Retomar", fim: "Finalizar vistoria", impedimento: "Impedimento", reagendada: "Reagendar", cancelada: "Cancelar" };
const hojeIso = () => new Date().toISOString().slice(0, 10);
const somaDias = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
const abrirHtml = async (url) => {
  try {
    const { data } = await suporteApi.get(url, { responseType: "text" });
    const j = window.open("", "_blank");
    if (j) { j.document.write(data); j.document.close(); }
  } catch (e) { toast.error(mensagemErro(e)); }
};

// Agendar visita: supervisor da fila da Supervisão, cliente da Base clientes e técnico do cadastro. Vindo de uma
// indicação (card de instalação finalizado), já chega com card, O.S, cliente e técnico preenchidos.
const NovaVisita = ({ open, onClose, onSalvo, opcoes, checklists = [], inicial = null }) => {
  const [f, setF] = useState({});
  const [cliente, setCliente] = useState(null);
  const [tecnico, setTecnico] = useState(null);
  useEffect(() => {
    if (!open) return;
    setF({ tipo: "instalacao_nova", area: "ALARME", supervisor: "", supervisor_user_id: null, supervisor_telefone: "", unidade: "", conta: "",
      objetivo: "", previsto_em: `${somaDias(hojeIso(), 1)}T09:00`, contato_local: "", instrucoes: "", os: "", checklist_codigo: "",
      card_id: null, ...(inicial?.campos || {}) });
    setCliente(null);
    setTecnico(null);
    if (inicial?.cliente_id) {
      suporteApi.get(`/api/clientes/${inicial.cliente_id}`).then((r) => {
        setCliente(r.data);
        setF((s) => ({ ...s, conta: r.data.conta || s.conta, unidade: r.data.nome || s.unidade }));
      }).catch(() => {});
    }
    if (inicial?.tecnico_id) suporteApi.get(`/api/tecnicos/${inicial.tecnico_id}`).then((r) => setTecnico(r.data)).catch(() => {});
    else if (inicial?.qra != null) suporteApi.get(`/api/tecnicos/qra/${inicial.qra}`).then((r) => setTecnico(r.data)).catch(() => {});
  }, [open, inicial]);
  const c = (k, rotulo, extra = {}) => <TextField id={`nv-${k}`} size="small" variant="outlined" margin="dense" fullWidth label={rotulo}
    value={f[k] ?? ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} />;
  const escolherCliente = (cli) => {
    setCliente(cli);
    if (cli) setF((s) => ({ ...s, conta: cli.conta, unidade: cli.nome }));
  };
  const salvar = async () => {
    try {
      await suporteApi.post("/api/supervisao/visitas", { ...f, os: f.os || null, conta: f.conta || null, checklist_codigo: f.checklist_codigo || null,
        cliente_id: cliente?.id || null, tecnico_id: tecnico?.id || null });
      toast.success("Visita agendada");
      onSalvo();
      onClose();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{inicial?.card_id ? `Agendar vistoria da instalação (card #${inicial.card_id})` : "Agendar visita"}</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", gap: 8 }}>
          {c("tipo", "Tipo", { select: true, children: Object.entries(opcoes.tipos || {}).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>) })}
          {c("area", "Área", { select: true, children: ["ALARME", "COFRES"].map((a) => <MenuItem key={a} value={a}>{a === "ALARME" ? "Alarme/CFTV/Acesso" : "Cofres/Guarda-volumes/Portas"}</MenuItem>) })}
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ flex: 1 }}>
            <SeletorSupervisor id="nv-supervisor" value={f.supervisor_user_id} texto={f.supervisor}
              onChange={(u) => setF((s) => ({ ...s, supervisor_user_id: u?.id || null, supervisor: u?.nome || "" }))}
              onTexto={(v) => setF((s) => ({ ...s, supervisor: v }))} />
          </div>
          <div style={{ flex: 1 }}>{c("supervisor_telefone", "Telefone do supervisor (chatbot)")}</div>
        </div>
        <SeletorCliente id="nv-cliente" value={cliente} onChange={escolherCliente} />
        <div style={{ display: "flex", gap: 8 }}>{c("unidade", "Unidade / loja")}{c("conta", "Conta")}{c("os", "O.S")}</div>
        <SeletorTecnico id="nv-tecnico" value={tecnico} onChange={setTecnico} label="Técnico responsável pelo atendimento" />
        {c("objetivo", "Objetivo", { multiline: true, minRows: 2 })}
        {c("checklist_codigo", "Checklist", { select: true, children: [<MenuItem key="" value="">Automático pelo tipo de visita</MenuItem>,
          ...checklists.map((k) => <MenuItem key={k.codigo} value={k.codigo}>{`${k.nome} (versão ${k.versao})`}</MenuItem>)] })}
        <div style={{ display: "flex", gap: 8 }}>
          {c("previsto_em", "Quando", { type: "datetime-local", InputLabelProps: { shrink: true } })}
          {c("contato_local", "Contato no local")}
        </div>
        {c("instrucoes", "Instruções de acesso", { multiline: true, minRows: 2 })}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cancelar</Button>
        <Button color="primary" variant="contained" disabled={!f.supervisor || !f.objetivo} onClick={salvar}>Agendar</Button></DialogActions>
    </Dialog>
  );
};

// Correções enviadas pelo técnico (formulário de correção): o supervisor aprova (ponto resolvido) ou reprova
// com motivo (o técnico é avisado e responde de novo pelo mesmo link)
const FilaCorrecoes = ({ itens, onMudou }) => {
  const pode = usePermissao("supervisao.validar");
  const decidir = async (a, aprovado) => {
    const justificativa = window.prompt(aprovado ? "Observação da aprovação:" : "Por que a correção não foi aprovada? (vai para o técnico)",
      aprovado ? "Correção conferida pelas fotos" : "");
    if (!justificativa || justificativa.trim().length < 3) return;
    try {
      await suporteApi.post(`/api/supervisao/apontamentos/${a.id}/validar`, { aprovado, justificativa });
      toast.success(aprovado ? `${a.numero} aprovado` : `${a.numero} devolvido ao técnico`);
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  if (!itens.length) return <Typography variant="body2" color="textSecondary" style={{ margin: "10px 0" }}>Nenhuma correção aguardando aprovação.</Typography>;
  return itens.map((a) => (
    <Paper key={a.id} variant="outlined" style={{ padding: 12, margin: "10px 0" }}>
      <Typography variant="subtitle2">
        <Chip size="small" label={a.gravidade} style={{ background: GRAV[a.gravidade], color: "#fff" }} /> {a.numero} · {a.problema}
      </Typography>
      <Typography variant="caption" color="textSecondary" component="div">
        {`${a.visita_numero} · ${a.unidade || a.conta || ""} · enviado por ${a.responsavel || "—"}${a.enviado_em ? ` em ${dataBR(a.enviado_em)}` : ""}`}
      </Typography>
      <Typography variant="body2" style={{ marginTop: 6 }}><b>O que foi feito:</b> {a.solucao_definitiva || "—"}</Typography>
      <Typography variant="body2"><b>Teste:</b> {a.teste_executado || "—"}</Typography>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginTop: 8 }}>
        <div><Typography variant="caption">Antes</Typography><div style={{ display: "flex", gap: 6 }}>
          {(a.fotos_antes || []).map((f) => <ImagemDaVisita key={f.arquivo} visitaId={a.visita_id} arquivo={f.arquivo} altura={120} />)}
        </div></div>
        <div><Typography variant="caption">Depois</Typography><div style={{ display: "flex", gap: 6 }}>
          {(a.fotos_depois || []).map((f) => <ImagemDaVisita key={f.arquivo} visitaId={a.visita_id} arquivo={f.arquivo} altura={120} />)}
        </div></div>
      </div>
      {pode && (
        <div style={{ marginTop: 8 }}>
          <Button size="small" color="primary" variant="contained" onClick={() => decidir(a, true)}>Aprovar correção</Button>{" "}
          <Button size="small" onClick={() => decidir(a, false)}>Reprovar</Button>
        </div>
      )}
    </Paper>
  ));
};

// Indicações: cards de instalação finalizados pelo suporte, para o supervisor agendar a vistoria ou descartar
const Indicacoes = ({ itens, onAgendar, onMudou }) => {
  const pode = usePermissao("supervisao.agendar");
  const descartar = async (x) => {
    const motivo = window.prompt(`Por que a instalação do card #${x.card_id} não terá vistoria?`);
    if (!motivo) return;
    try {
      await suporteApi.post(`/api/supervisao/indicacoes/${x.card_id}/descartar`, { motivo });
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <>
      <Typography variant="body2" color="textSecondary" style={{ margin: "10px 0" }}>
        Cards de instalação finalizados pelo suporte nos últimos 60 dias, sem O.S pendente. Saem da lista ao agendar a vistoria ou ao descartar.
      </Typography>
      <Paper variant="outlined" style={{ overflowX: "auto" }}>
        <Table size="small">
          <TableHead><TableRow><TableCell>Card</TableCell><TableCell>Finalizado</TableCell><TableCell>Cliente</TableCell><TableCell>Conta</TableCell>
            <TableCell>O.S</TableCell><TableCell>Técnico</TableCell><TableCell>Validado por</TableCell><TableCell /></TableRow></TableHead>
          <TableBody>
            {itens.length === 0 && <TableRow><TableCell colSpan={8}><Typography variant="body2" color="textSecondary">Nenhuma instalação aguardando vistoria.</Typography></TableCell></TableRow>}
            {itens.map((x) => (
              <TableRow key={x.card_id}>
                <TableCell>#{x.card_id}</TableCell><TableCell>{dataBR(x.finalizado_em)}</TableCell><TableCell>{x.cliente || "—"}</TableCell>
                <TableCell>{x.conta || "—"}</TableCell><TableCell>{x.os || "—"}</TableCell>
                <TableCell>{x.qra != null ? `QRA ${x.qra} · ` : ""}{x.tecnico || "—"}</TableCell><TableCell>{x.validado_por || "—"}</TableCell>
                <TableCell style={{ whiteSpace: "nowrap" }}>
                  {pode && <Button size="small" color="primary" variant="outlined" onClick={() => onAgendar(x)}>Agendar vistoria</Button>}
                  {pode && <Button size="small" onClick={() => descartar(x)}>Descartar</Button>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
};

// Imagem de arquivo da visita (a rota exige login: baixa com o token e mostra pelo endereço local)
const ImagemDaVisita = ({ visitaId, arquivo, altura = 90 }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let local = null;
    suporteApi.get(`/api/supervisao/arquivos/${visitaId}/${arquivo}`, { responseType: "blob" })
      .then((r) => { local = URL.createObjectURL(r.data); setUrl(local); }).catch(() => setUrl(null));
    return () => { if (local) URL.revokeObjectURL(local); };
  }, [visitaId, arquivo]);
  return url ? <img src={url} alt="assinatura" style={{ maxHeight: altura, border: "1px solid #ddd", borderRadius: 6, background: "#fff" }} /> : null;
};

// Um item do checklist, conforme o tipo: verificação (conforme / não conforme…), texto, escolha, caixas, lista,
// data, hora, número, fotos ou assinatura. Cada item é gravado sozinho (o servidor confere tipo e condição).
const ItemChecklist = ({ visita, item, resposta, podeExecutar, opcoes, onSalvo }) => {
  const valorInicial = item.tipo === "verificacao" ? resposta?.resposta || "" : resposta?.valor ?? (item.tipo === "caixas" ? [] : "");
  const [f, setF] = useState({ resposta: valorInicial, justificativa: resposta?.justificativa || "", observacao: resposta?.observacao || "", gravidade: "MEDIA" });
  const [fotos, setFotos] = useState([]);
  const [assinatura, setAssinatura] = useState(null);
  const editavel = podeExecutar && ["EM_VISTORIA", "PAUSADA", "FINALIZADA"].includes(visita.status);
  if (item.tipo === "secao") {
    return <Typography variant="subtitle2" style={{ marginTop: 14, color: "#2e7d32" }}>{item.titulo}</Typography>;
  }
  const salvar = async () => {
    const corpo = new FormData();
    const valor = item.tipo === "caixas" ? JSON.stringify(f.resposta || []) : f.resposta;
    corpo.append("resposta", ["foto", "assinatura"].includes(item.tipo) ? "" : valor);
    ["justificativa", "observacao", "gravidade"].forEach((k) => corpo.append(k, f[k]));
    fotos.forEach((x) => corpo.append("fotos", x));
    if (assinatura) corpo.append("fotos", new File([assinatura], "assinatura.png", { type: "image/png" }));
    try {
      await suporteApi.post(`/api/supervisao/visitas/${visita.id}/itens/${item.id}`, corpo);
      setFotos([]);
      setAssinatura(null);
      onSalvo();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const resumo = () => {
    if (!resposta) return null;
    if (item.tipo === "verificacao") return opcoes.respostas[resposta.resposta];
    if (item.tipo === "foto") return `${resposta.fotos.length} foto(s)`;
    if (item.tipo === "assinatura") return "Assinado";
    return Array.isArray(resposta.valor) ? resposta.valor.join(", ") : resposta.valor;
  };
  const pronto = { foto: fotos.length > 0, assinatura: !!assinatura, caixas: (f.resposta || []).length > 0 }[item.tipo] ?? !!f.resposta;
  let campo;
  if (item.tipo === "verificacao") {
    campo = (
      <>
        <TextField select size="small" value={f.resposta} onChange={(e) => setF({ ...f, resposta: e.target.value })} style={{ minWidth: 160 }} label="Resposta">
          {Object.entries(opcoes.respostas).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
        </TextField>
        {["NAO_SE_APLICA", "NAO_VERIFICADO"].includes(f.resposta) && (
          <TextField size="small" label="Justificativa (obrigatória)" value={f.justificativa} onChange={(e) => setF({ ...f, justificativa: e.target.value })} />
        )}
        {f.resposta === "NAO_CONFORME" && (
          <TextField select size="small" label="Gravidade" value={f.gravidade} onChange={(e) => setF({ ...f, gravidade: e.target.value })}>
            {opcoes.gravidades.map((g) => <MenuItem key={g} value={g}>{g}</MenuItem>)}
          </TextField>
        )}
      </>
    );
  } else if (item.tipo === "escolha") {
    campo = (
      <RadioGroup row value={f.resposta} onChange={(e) => setF({ ...f, resposta: e.target.value })}>
        {item.opcoes.map((o) => <FormControlLabel key={o} value={o} control={<Radio size="small" color="primary" />} label={o} />)}
      </RadioGroup>
    );
  } else if (item.tipo === "caixas") {
    const marcadas = f.resposta || [];
    campo = item.opcoes.map((o) => (
      <FormControlLabel key={o} label={o} control={<Checkbox size="small" color="primary" checked={marcadas.includes(o)}
        onChange={(e) => setF({ ...f, resposta: e.target.checked ? [...marcadas, o] : marcadas.filter((x) => x !== o) })} />} />
    ));
  } else if (item.tipo === "lista") {
    campo = (
      <TextField select size="small" label="Escolha" value={f.resposta} onChange={(e) => setF({ ...f, resposta: e.target.value })} style={{ minWidth: 200 }}>
        {item.opcoes.map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
      </TextField>
    );
  } else if (item.tipo === "assinatura") {
    const salva = (resposta?.fotos || []).slice(-1)[0];
    campo = (
      <div style={{ width: "100%", maxWidth: 480 }}>
        {salva && <Typography variant="caption" color="textSecondary" component="div">Assinatura registrada (assine de novo para trocar):</Typography>}
        {salva && <ImagemDaVisita visitaId={visita.id} arquivo={salva.arquivo} />}
        <QuadroAssinatura onChange={setAssinatura} />
      </div>
    );
  } else if (item.tipo !== "foto") {
    const tipo = { data: "date", hora: "time", numero: "number" }[item.tipo] || "text";
    campo = (
      <TextField size="small" label="Resposta" type={tipo} InputLabelProps={{ shrink: true }} multiline={item.tipo === "paragrafo"}
        minRows={item.tipo === "paragrafo" ? 2 : undefined} value={f.resposta} onChange={(e) => setF({ ...f, resposta: e.target.value })}
        style={{ minWidth: item.tipo === "paragrafo" ? 360 : 200 }} />
    );
  }
  const aceitaFotos = item.tipo === "verificacao" || item.tipo === "foto";
  return (
    <div style={{ padding: "8px 0", borderTop: "1px solid rgba(0,0,0,.08)" }}>
      <Typography variant="body2"><b>{item.titulo}</b>{item.obrigatorio ? " *" : ""}{item.exige_foto ? " (exige foto)" : ""}
        {resposta && <Chip size="small" label={resumo()} style={{ marginLeft: 6 }} />}
        {resposta && item.tipo === "verificacao" && resposta.fotos.length > 0 && <Typography variant="caption"> · {resposta.fotos.length} foto(s)</Typography>}</Typography>
      {item.ajuda && <Typography variant="caption" color="textSecondary" component="div">{item.ajuda}</Typography>}
      {!editavel && item.tipo === "assinatura" && (resposta?.fotos || []).length > 0 && (
        <ImagemDaVisita visitaId={visita.id} arquivo={resposta.fotos.slice(-1)[0].arquivo} />
      )}
      {editavel && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center" }}>
          {campo}
          {item.tipo !== "assinatura" && (
            <TextField size="small" label="Observação" value={f.observacao} onChange={(e) => setF({ ...f, observacao: e.target.value })} />
          )}
          {aceitaFotos && (
            <Button size="small" component="label">Fotos ({fotos.length})
              <input hidden multiple type="file" accept="image/*,video/*,application/pdf" onChange={(e) => setFotos(Array.from(e.target.files || []))} />
            </Button>
          )}
          <Button size="small" color="primary" variant="outlined" disabled={!pronto} onClick={salvar}>Salvar</Button>
        </div>
      )}
    </div>
  );
};

// Editor do checklist: mesmos tipos e condições dos formulários + verificação. Salvar cria uma nova versão
// (visitas antigas continuam com a versão que usaram).
const EditorChecklist = ({ inicial, opcoes, onClose, onSalvo }) => {
  const [c, setC] = useState(null);
  const [sel, setSel] = useState(0);
  const [menu, setMenu] = useState(null);
  useEffect(() => {
    if (!inicial) { setC(null); return; }
    setC({ ...inicial, itens: (inicial.itens || []).map((i) => ({ ...i, obrigatoria: i.obrigatorio ?? i.obrigatoria })) });
    setSel(0);
  }, [inicial]);
  if (!c) return null;
  const mudar = (i, dados) => setC((s) => ({ ...s, itens: s.itens.map((x, j) => (j === i ? { ...x, ...dados } : x)) }));
  const mover = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= c.itens.length) return;
    setC((s) => { const xs = [...s.itens]; [xs[i], xs[j]] = [xs[j], xs[i]]; return { ...s, itens: xs }; });
    setSel(j);
  };
  const inserir = (item) => {
    const pos = c.itens.length ? Math.min(sel + 1, c.itens.length) : 0;
    setC((s) => { const xs = [...s.itens]; xs.splice(pos, 0, item); return { ...s, itens: xs }; });
    setSel(pos);
  };
  const duplicar = (i) => inserir({ ...JSON.parse(JSON.stringify(c.itens[i])), id: novaPergunta().id, titulo: `${c.itens[i].titulo} (cópia)` });
  const remover = (i) => { setC((s) => ({ ...s, itens: s.itens.filter((_, j) => j !== i) })); setSel(Math.max(0, i - 1)); };
  const salvar = async () => {
    const vazio = c.itens.findIndex((x) => !(x.titulo || "").trim());
    if (vazio >= 0) { setSel(vazio); return toast.error(`O item ${vazio + 1} está sem título`); }
    try {
      await suporteApi.post("/api/supervisao/checklists", {
        codigo: c.codigo || null, nome: c.nome, tipo_visita: c.tipo_visita || null, area: c.area || null,
        itens: c.itens.map(({ obrigatoria, ...x }) => ({ ...x, obrigatorio: !!obrigatoria })),
      });
      toast.success(c.codigo ? "Nova versão do checklist salva" : "Checklist criado");
      onSalvo();
      onClose();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const item = c.itens[sel];
  const ROT = Object.fromEntries(TIPOS_CHECKLIST);
  return (
    <Dialog open fullScreen onClose={onClose}>
      <div style={{ display: "flex", gap: 10, alignItems: "center", padding: "10px 16px", borderBottom: "1px solid rgba(0,0,0,.12)", flexWrap: "wrap" }}>
        <TextField id="ck-nome" placeholder="Nome do checklist" value={c.nome || ""} onChange={(e) => setC({ ...c, nome: e.target.value })}
          InputProps={{ style: { fontSize: 20, fontWeight: 600 } }} style={{ flex: "1 1 260px" }} />
        <TextField select size="small" label="Tipo de visita" value={c.tipo_visita || ""} onChange={(e) => setC({ ...c, tipo_visita: e.target.value })} style={{ minWidth: 220 }}>
          <MenuItem value="">Qualquer tipo</MenuItem>
          {Object.entries(opcoes.tipos).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
        </TextField>
        {c.codigo && <Chip size="small" label={`Salvar cria a versão ${(c.versao || 0) + 1}`} />}
        <Button onClick={onClose}>Cancelar</Button>
        <Button color="primary" variant="contained" disabled={(c.nome || "").trim().length < 3} onClick={salvar}>Salvar</Button>
      </div>
      <div style={{ padding: 16, overflow: "auto" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Paper variant="outlined">
              <Typography variant="subtitle2" style={{ padding: "10px 12px 0" }}>{`Itens (${c.itens.length})`}</Typography>
              <List dense>
                {c.itens.map((x, i) => (
                  <ListItem key={x.id} button selected={i === sel} onClick={() => setSel(i)}
                    style={x.tipo === "secao" ? { background: "rgba(46,125,50,0.08)" } : undefined}>
                    <ListItemText primary={<span style={{ fontWeight: x.tipo === "secao" ? 700 : 400 }}>{`${i + 1}. ${x.titulo || "(sem título)"}`}{x.obrigatoria ? " *" : ""}</span>}
                      secondary={[ROT[x.tipo || "verificacao"], x.condicao && "condicional"].filter(Boolean).join(" · ")} />
                  </ListItem>
                ))}
              </List>
              <div style={{ padding: "0 8px 8px", display: "flex", gap: 6 }}>
                <Button size="small" color="primary" startIcon={<AddIcon />} onClick={(e) => setMenu(e.currentTarget)}>Item</Button>
                <Button size="small" startIcon={<AddIcon />} onClick={() => inserir(novaPergunta("secao"))}>Seção</Button>
              </div>
              <Menu anchorEl={menu} open={!!menu} onClose={() => setMenu(null)}>
                {TIPOS_CHECKLIST.filter(([v]) => v !== "secao").map(([v, r]) => (
                  <MenuItem key={v} onClick={() => { setMenu(null); inserir({ ...novaPergunta(v), obrigatoria: v !== "secao" }); }}>{r}</MenuItem>
                ))}
              </Menu>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8}>
            {item ? (
              <EditorPergunta p={{ ...item, tipo: item.tipo || "verificacao" }} i={sel} total={c.itens.length} anteriores={c.itens.slice(0, sel)}
                mudar={mudar} mover={mover} duplicar={duplicar} remover={remover} tipos={TIPOS_CHECKLIST} checklist />
            ) : (
              <Paper variant="outlined" style={{ padding: 24, textAlign: "center" }}>
                <Typography color="textSecondary">Nenhum item ainda. Use “+ Item” para começar.</Typography>
              </Paper>
            )}
            {item && item.tipo !== "secao" && (
              <Paper variant="outlined" style={{ padding: 12, marginTop: 12 }}>
                <Typography variant="caption" color="textSecondary">Prévia deste item</Typography>
                <PreviaPergunta p={{ ...item, tipo: item.tipo || "verificacao" }} todas={c.itens} />
              </Paper>
            )}
          </Grid>
        </Grid>
      </div>
    </Dialog>
  );
};

const DetalheVisita = ({ id, onClose, opcoes, onMudou }) => {
  const [v, setV] = useState(null);
  const [concl, setConcl] = useState({ resultado: "", conclusao: "" });
  const podeExecutar = usePermissao("supervisao.executar");
  const podeValidar = usePermissao("supervisao.validar");
  const carregar = useCallback(() => {
    if (!id) return;
    suporteApi.get(`/api/supervisao/visitas/${id}`).then((r) => setV(r.data)).catch((e) => toast.error(mensagemErro(e)));
  }, [id]);
  useEffect(() => { setV(null); carregar(); }, [carregar]);
  if (!id) return null;
  const evento = async (tipo) => {
    const corpo = { tipo };
    if (["impedimento", "reagendada", "cancelada"].includes(tipo)) {
      const motivo = window.prompt(tipo === "impedimento" ? `Motivo (${opcoes.impedimentos.join(", ")}):` : "Motivo:");
      if (!motivo) return;
      corpo.motivo = motivo;
    }
    if (tipo === "reagendada") {
      const novo = window.prompt("Nova data e hora (AAAA-MM-DDTHH:MM):", `${somaDias(hojeIso(), 1)}T09:00`);
      if (!novo) return;
      corpo.novo_previsto_em = novo;
    }
    try {
      setV((await suporteApi.post(`/api/supervisao/visitas/${id}/eventos`, corpo)).data);
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const concluir = async () => {
    try {
      setV((await suporteApi.post(`/api/supervisao/visitas/${id}/concluir`, concl)).data);
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const emitir = async () => {
    try {
      const { data } = await suporteApi.post(`/api/supervisao/visitas/${id}/relatorio`);
      toast.success(`Relatório versão ${data.versao} emitido`);
      carregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const novoApontamento = async () => {
    const problema = window.prompt("Descreva o problema encontrado:");
    if (!problema) return;
    try {
      await suporteApi.post(`/api/supervisao/visitas/${id}/apontamentos`, { problema, gravidade: "MEDIA" });
      carregar();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{v ? `${v.numero} · ${opcoes.tipos[v.tipo] || v.tipo}` : "Visita"}</DialogTitle>
      <DialogContent>
        {!v ? <CircularProgress size={24} /> : (
          <>
            <Typography variant="body2">
              <Chip size="small" label={SIT[v.status] || v.status} style={{ background: COR[v.status] || "#1565c0", color: "#fff" }} />
              {v.resultado && <Chip size="small" label={opcoes.resultados[v.resultado]} style={{ marginLeft: 6 }} />}
              {" "}{v.unidade || "—"} {v.conta ? `(conta ${v.conta})` : ""} · {v.supervisor} · previsto {dataBR(v.previsto_em)}
            </Typography>
            <Typography variant="body2" style={{ margin: "6px 0" }}>{v.objetivo}</Typography>
            <Typography variant="caption" component="div">
              Tempos: deslocamento {v.tempos.deslocamento_min ?? "—"} min · espera {v.tempos.espera_min ?? "—"} min ·
              vistoria ativa {v.tempos.vistoria_ativa_min ?? "—"} min · pausas {v.tempos.pausas_min} min
            </Typography>
            {podeExecutar && (EVENTOS[v.status] || []).length > 0 && (
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", margin: "8px 0" }}>
                {EVENTOS[v.status].map((e) => <Button key={e} size="small" variant="outlined" onClick={() => evento(e)}>{NOME_EV[e]}</Button>)}
              </div>
            )}
            <Typography variant="subtitle2" style={{ marginTop: 10 }}>
              Checklist {v.checklist ? `${v.checklist.nome} (versão ${v.checklist.versao})` : "—"}
              {v.pendentes.length > 0 && <Typography variant="caption" color="secondary"> · {v.pendentes.length} obrigatório(s) pendente(s)</Typography>}
            </Typography>
            {(v.checklist?.itens || []).filter((i) => !(v.ocultos || []).includes(i.id)).map((i) => (
              <ItemChecklist key={`${i.id}-${v.respostas[i.id]?.respondido_em || ""}`} visita={v} item={i} resposta={v.respostas[i.id]}
                podeExecutar={podeExecutar} opcoes={opcoes} onSalvo={carregar} />
            ))}
            <Typography variant="subtitle2" style={{ marginTop: 12 }}>Apontamentos ({v.apontamentos.length})
              {podeExecutar && <Button size="small" onClick={novoApontamento}>Novo</Button>}</Typography>
            {v.apontamentos.map((a) => (
              <Typography key={a.id} variant="body2">
                <Chip size="small" label={a.gravidade} style={{ background: GRAV[a.gravidade], color: "#fff" }} /> {a.numero} · {a.problema} ·{" "}
                <b>{opcoes.situacoes_apontamento[a.status]}</b>{a.responsavel ? ` · ${a.responsavel}` : ""}{a.prazo ? ` até ${dataBR(a.prazo, true)}` : ""}
              </Typography>
            ))}
            {["EM_VISTORIA", "PAUSADA", "FINALIZADA"].includes(v.status) && podeExecutar && (
              <div style={{ marginTop: 12, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
                <Typography variant="subtitle2" style={{ width: "100%" }}>Concluir vistoria (o laudo é gerado na hora)</Typography>
                <TextField select size="small" label="Resultado" value={concl.resultado} onChange={(e) => setConcl({ ...concl, resultado: e.target.value })} style={{ minWidth: 220 }}>
                  {Object.entries(opcoes.resultados).map(([k, x]) => <MenuItem key={k} value={k}>{x}</MenuItem>)}
                </TextField>
                <TextField size="small" label="Conclusão" value={concl.conclusao} onChange={(e) => setConcl({ ...concl, conclusao: e.target.value })} style={{ flex: 1 }} />
                <Button id="concluir-vistoria" color="primary" variant="contained" disabled={!concl.resultado || concl.conclusao.length < 3 || v.pendentes.length > 0} onClick={concluir}>Concluir</Button>
                {v.pendentes.length > 0 && <Typography variant="caption" color="secondary">Responda os itens obrigatórios do checklist antes de concluir.</Typography>}
              </div>
            )}
            <LaudoDaVisita visita={v} />
            <Typography variant="subtitle2" style={{ marginTop: 12 }}>Relatórios emitidos</Typography>
            {v.relatorios.map((r) => (
              <Button key={r.id} size="small" onClick={() => abrirHtml(`/api/supervisao/visitas/${id}/relatorio/${r.versao}`)}>
                Versão {r.versao} · {dataBR(r.emitido_em)}
              </Button>
            ))}
            {podeValidar && ["FINALIZADA", "CONCLUIDA"].includes(v.status) && <Button size="small" color="primary" onClick={emitir}>Emitir nova versão</Button>}
            <Typography variant="subtitle2" style={{ marginTop: 12 }}>Linha do tempo</Typography>
            {v.eventos.map((e) => (
              <Typography key={e.id} variant="caption" component="div" style={{ textDecoration: e.anulado ? "line-through" : "none" }}>
                {dataBR(e.quando)} · {e.tipo}{e.motivo ? ` (${e.motivo})` : ""} · {e.por || ""} {e.origem === "bot" ? "· WhatsApp" : ""}
              </Typography>
            ))}
          </>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
    </Dialog>
  );
};

const DetalheApontamento = ({ id, onClose, opcoes, onMudou }) => {
  const [a, setA] = useState(null);
  const [f, setF] = useState({});
  const [just, setJust] = useState("");
  const podeExecutar = usePermissao("supervisao.executar");
  const podeValidar = usePermissao("supervisao.validar");
  const carregar = useCallback(() => {
    if (!id) return;
    suporteApi.get(`/api/supervisao/apontamentos/${id}`).then((r) => {
      setA(r.data);
      setF({ responsavel: r.data.responsavel || "", prazo: r.data.prazo || "", teste_executado: r.data.teste_executado || "", status: "" });
    }).catch((e) => toast.error(mensagemErro(e)));
  }, [id]);
  useEffect(() => { setA(null); carregar(); }, [carregar]);
  if (!id) return null;
  const salvar = async () => {
    try {
      await suporteApi.put(`/api/supervisao/apontamentos/${id}`, { ...f, status: f.status || null, prazo: f.prazo || null,
        responsavel: f.responsavel || null, teste_executado: f.teste_executado || null });
      carregar();
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  const foto = async (arquivos) => {
    const corpo = new FormData();
    corpo.append("momento", "depois");
    Array.from(arquivos).forEach((x) => corpo.append("fotos", x));
    try { await suporteApi.post(`/api/supervisao/apontamentos/${id}/fotos`, corpo); carregar(); } catch (e) { toast.error(mensagemErro(e)); }
  };
  const validar = async (aprovado) => {
    try {
      await suporteApi.post(`/api/supervisao/apontamentos/${id}/validar`, { aprovado, justificativa: just });
      carregar();
      onMudou();
    } catch (e) { toast.error(mensagemErro(e)); }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{a ? `${a.numero} · ${opcoes.situacoes_apontamento[a.status]}` : "Apontamento"}</DialogTitle>
      <DialogContent>
        {!a ? <CircularProgress size={24} /> : (
          <>
            <Typography variant="body2"><Chip size="small" label={a.gravidade} style={{ background: GRAV[a.gravidade], color: "#fff" }} /> {a.problema}</Typography>
            <Typography variant="caption">Fotos antes: {a.fotos_antes.length} · depois: {a.fotos_depois.length}{a.reincidencia_de ? " · reincidência" : ""}</Typography>
            {podeExecutar && a.status !== "RESOLVIDO" && (
              <>
                <div style={{ display: "flex", gap: 8 }}>
                  <TextField size="small" margin="dense" label="Responsável" value={f.responsavel} onChange={(e) => setF({ ...f, responsavel: e.target.value })} />
                  <TextField size="small" margin="dense" type="date" label="Prazo" InputLabelProps={{ shrink: true }} value={f.prazo} onChange={(e) => setF({ ...f, prazo: e.target.value })} />
                  <TextField select size="small" margin="dense" label="Mudar para" value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} style={{ minWidth: 170 }}>
                    <MenuItem value="">—</MenuItem>
                    {["RESPONSAVEL_DEFINIDO", "EM_CORRECAO", "AGUARDANDO_VALIDACAO"].map((s) => <MenuItem key={s} value={s}>{opcoes.situacoes_apontamento[s]}</MenuItem>)}
                  </TextField>
                </div>
                <TextField size="small" margin="dense" fullWidth label="Teste executado (evidência posterior)" value={f.teste_executado} onChange={(e) => setF({ ...f, teste_executado: e.target.value })} />
                <Button size="small" component="label">Foto depois<input hidden multiple type="file" accept="image/*,video/*" onChange={(e) => foto(e.target.files)} /></Button>
                <Button size="small" color="primary" variant="outlined" onClick={salvar}>Salvar</Button>
              </>
            )}
            {podeValidar && a.status === "AGUARDANDO_VALIDACAO" && (
              <div style={{ marginTop: 10 }}>
                <TextField size="small" fullWidth label="Justificativa da validação" value={just} onChange={(e) => setJust(e.target.value)} />
                <Button size="small" color="primary" disabled={just.length < 3} onClick={() => validar(true)}>Aprovar correção</Button>
                <Button size="small" disabled={just.length < 3} onClick={() => validar(false)}>Reprovar</Button>
                <Typography variant="caption" component="div">A validação é feita por outra pessoa, não pelo responsável da correção.</Typography>
              </div>
            )}
            <Typography variant="subtitle2" style={{ marginTop: 10 }}>Histórico</Typography>
            {a.historico.map((h) => <Typography key={h.id} variant="caption" component="div">{dataBR(h.quando)} · {h.por}: {h.de ? `${h.de} → ` : ""}{h.para}{h.texto ? ` — ${h.texto}` : ""}</Typography>)}
          </>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
    </Dialog>
  );
};

const Supervisao = () => {
  const [aba, setAba] = useState("agenda");
  const [opcoes, setOpcoes] = useState(null);
  const [filtro, setFiltro] = useState({ de: somaDias(hojeIso(), -7), ate: somaDias(hojeIso(), 14), status: "" });
  const [visitas, setVisitas] = useState([]);
  const [aps, setAps] = useState([]);
  const [filtroAp, setFiltroAp] = useState("ABERTOS");
  const [checklists, setChecklists] = useState([]);
  const [nova, setNova] = useState(false);
  const [visita, setVisita] = useState(null);
  const [ap, setAp] = useState(null);
  const podeAgendar = usePermissao("supervisao.agendar");
  const podeChecklists = usePermissao("supervisao.checklists");
  const [editando, setEditando] = useState(null);
  const [indicacoes, setIndicacoes] = useState([]);
  const [correcoes, setCorrecoes] = useState([]);
  const [inicial, setInicial] = useState(null);

  useEffect(() => { suporteApi.get("/api/supervisao/opcoes").then((r) => setOpcoes(r.data)).catch((e) => toast.error(mensagemErro(e))); }, []);
  const carregar = useCallback(() => {
    suporteApi.get("/api/supervisao/visitas", { params: filtro }).then((r) => setVisitas(r.data)).catch(() => {});
    suporteApi.get("/api/supervisao/apontamentos", { params: filtroAp === "VENCIDOS" ? { vencidos: true } : { status: filtroAp } })
      .then((r) => setAps(r.data)).catch(() => {});
    suporteApi.get("/api/supervisao/checklists").then((r) => setChecklists(r.data)).catch(() => {});
    suporteApi.get("/api/supervisao/indicacoes").then((r) => setIndicacoes(r.data)).catch(() => {});
    suporteApi.get("/api/supervisao/correcoes").then((r) => setCorrecoes(r.data)).catch(() => {});
  }, [filtro, filtroAp]);
  useEffect(() => { carregar(); }, [carregar]);
  const fecharVisita = useCallback(() => setVisita(null), []);
  const fecharAp = useCallback(() => setAp(null), []);
  if (!opcoes) return <MainContainer><CircularProgress size={24} /></MainContainer>;

  return (
    <MainContainer>
      <MainHeader>
        <Title>Supervisão de campo</Title>
        {podeAgendar && <Button size="small" variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => setNova(true)}>Agendar visita</Button>}
      </MainHeader>
      <Tabs value={aba} onChange={(e, v) => setAba(v)} indicatorColor="primary" textColor="primary">
        <Tab value="agenda" label="Agenda" /><Tab value="indicacoes" label={`Indicações (${indicacoes.length})`} /><Tab value="correcoes" label={`Correções (${correcoes.length})`} /><Tab value="apontamentos" label={`Apontamentos (${aps.length})`} /><Tab value="checklists" label="Checklists" /><Tab value="textos" label="Textos padrão" />
      </Tabs>
      {aba === "agenda" && (
        <>
          <div style={{ display: "flex", gap: 8, margin: "10px 0", flexWrap: "wrap" }}>
            <TextField size="small" type="date" label="De" InputLabelProps={{ shrink: true }} value={filtro.de} onChange={(e) => setFiltro({ ...filtro, de: e.target.value })} />
            <TextField size="small" type="date" label="Até" InputLabelProps={{ shrink: true }} value={filtro.ate} onChange={(e) => setFiltro({ ...filtro, ate: e.target.value })} />
            <TextField size="small" select label="Situação" value={filtro.status} onChange={(e) => setFiltro({ ...filtro, status: e.target.value })} style={{ minWidth: 160 }}>
              <MenuItem value="">Todas</MenuItem>{Object.entries(SIT).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
            </TextField>
          </div>
          <Paper variant="outlined" style={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>Nº</TableCell><TableCell>Previsto</TableCell><TableCell>Tipo</TableCell><TableCell>Unidade</TableCell>
                <TableCell>Supervisor</TableCell><TableCell>Situação</TableCell><TableCell>Resultado</TableCell><TableCell>Apont. abertos</TableCell></TableRow></TableHead>
              <TableBody>
                {visitas.length === 0 && <TableRow><TableCell colSpan={8}><Typography variant="body2" color="textSecondary">Nenhuma visita no período.</Typography></TableCell></TableRow>}
                {visitas.map((v) => (
                  <TableRow key={v.id} hover style={{ cursor: "pointer" }} onClick={() => setVisita(v.id)}>
                    <TableCell>{v.numero}</TableCell><TableCell>{dataBR(v.previsto_em)}</TableCell><TableCell>{opcoes.tipos[v.tipo]}</TableCell>
                    <TableCell>{v.unidade || v.conta || "—"}</TableCell><TableCell>{v.supervisor}</TableCell>
                    <TableCell><Chip size="small" label={SIT[v.status]} style={{ background: COR[v.status] || "#1565c0", color: "#fff" }} /></TableCell>
                    <TableCell>{v.resultado ? opcoes.resultados[v.resultado] : "—"}</TableCell><TableCell>{v.apontamentos_abertos}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
      {aba === "correcoes" && <FilaCorrecoes itens={correcoes} onMudou={carregar} />}
      {aba === "apontamentos" && (
        <>
          <TextField size="small" select value={filtroAp} onChange={(e) => setFiltroAp(e.target.value)} style={{ margin: "10px 0", minWidth: 200 }}>
            <MenuItem value="ABERTOS">Em aberto</MenuItem><MenuItem value="VENCIDOS">Vencidos</MenuItem>
            {Object.entries(opcoes.situacoes_apontamento).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
          </TextField>
          <Paper variant="outlined" style={{ overflowX: "auto" }}>
            <Table size="small">
              <TableHead><TableRow><TableCell>Nº</TableCell><TableCell>Gravidade</TableCell><TableCell>Problema</TableCell><TableCell>Visita</TableCell>
                <TableCell>Responsável</TableCell><TableCell>Prazo</TableCell><TableCell>Situação</TableCell></TableRow></TableHead>
              <TableBody>
                {aps.map((a) => (
                  <TableRow key={a.id} hover style={{ cursor: "pointer" }} onClick={() => setAp(a.id)}>
                    <TableCell>{a.numero}</TableCell><TableCell><Chip size="small" label={a.gravidade} style={{ background: GRAV[a.gravidade], color: "#fff" }} /></TableCell>
                    <TableCell>{a.problema}</TableCell><TableCell>{a.visita_numero} · {a.unidade || a.conta || ""}</TableCell>
                    <TableCell>{a.responsavel || "—"}</TableCell><TableCell>{a.prazo ? dataBR(a.prazo, true) : "—"}</TableCell>
                    <TableCell>{opcoes.situacoes_apontamento[a.status]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </>
      )}
      {aba === "textos" && <TextosLaudo />}
      {aba === "indicacoes" && (
        <Indicacoes itens={indicacoes} onMudou={carregar} onAgendar={(x) => {
          setInicial({ card_id: x.card_id, cliente_id: x.cliente_id, tecnico_id: x.tecnico_id, qra: x.qra,
            campos: { tipo: "instalacao_nova", card_id: x.card_id, os: x.os || "", conta: x.conta || "", unidade: x.cliente || "",
              area: x.area === "COFRES" ? "COFRES" : "ALARME", objetivo: `Vistoria da instalação nova (card #${x.card_id}${x.os ? `, O.S ${x.os}` : ""})` } });
          setNova(true);
        }} />
      )}
      {aba === "checklists" && podeChecklists && (
        <Button size="small" startIcon={<AddIcon />} style={{ margin: "10px 0" }}
          onClick={() => setEditando({ nome: "", tipo_visita: "", itens: [{ ...novaPergunta("verificacao"), obrigatoria: true }] })}>Novo checklist</Button>
      )}
      {aba === "checklists" && checklists.map((c) => (
        <Paper key={c.id} variant="outlined" style={{ padding: 12, margin: "10px 0" }}>
          <Typography variant="subtitle2">{c.nome} · versão {c.versao} {c.tipo_visita ? `· ${opcoes.tipos[c.tipo_visita]}` : ""}
            {podeChecklists && <Button size="small" color="primary" onClick={() => setEditando(c)}>Editar</Button>}</Typography>
          {c.itens.map((i) => (
            <Typography key={i.id} variant="body2" style={i.tipo === "secao" ? { fontWeight: 700, marginTop: 6 } : undefined}>
              {i.tipo === "secao" ? i.titulo : `• ${i.secao ? `${i.secao}: ` : ""}${i.titulo}${i.obrigatorio ? " *" : ""}`}
              {i.tipo !== "secao" && <Typography component="span" variant="caption" color="textSecondary">{` · ${(opcoes.tipos_item || {})[i.tipo] || i.tipo}${i.exige_foto ? " · exige foto" : ""}${i.condicao ? " · condicional" : ""}`}</Typography>}
            </Typography>
          ))}
        </Paper>
      ))}
      <EditorChecklist inicial={editando} opcoes={opcoes} onClose={() => setEditando(null)} onSalvo={carregar} />
      <NovaVisita open={nova} onClose={() => { setNova(false); setInicial(null); }} onSalvo={carregar} opcoes={opcoes} checklists={checklists} inicial={inicial} />
      <DetalheVisita id={visita} onClose={fecharVisita} opcoes={opcoes} onMudou={carregar} />
      <DetalheApontamento id={ap} onClose={fecharAp} opcoes={opcoes} onMudou={carregar} />
    </MainContainer>
  );
};

export default Supervisao;
